import AppChatnBuy from '@/pages/AppChatnBuy/Template'
import Points from '@/pages/AppChatnBuy/Points'
import Order from '@/pages/AppChatnBuy/Order'
import Account from '@/pages/AppChatnBuy/Account'
export default {
    path: '/AppChatnBuy',
    component: AppChatnBuy,
    children: [
        {
            path: '',
            name: 'AppChatnBuyPoints',
            component: Points,
        },
        {
            path: ':id/:id1',
            name: 'AppChatnBuyOrder',
            component: Order,
        },
        {
            path: 'account',
            name: 'AppChatnBuyAccount',
            component: Account,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/appchatnbuy.js